export var DateAccuracy;
(function (DateAccuracy) {
    DateAccuracy["Date"] = "date";
    DateAccuracy["DateTime"] = "datetime";
    DateAccuracy["DateTimeWithSeconds"] = "datetime-seconds";
    DateAccuracy["DateTimeWithMilliseconds"] = "datetime-milliseconds";
    DateAccuracy["Time"] = "time";
    DateAccuracy["TimeWithSeconds"] = "time-seconds";
    DateAccuracy["TimeWithMilliseconds"] = "time-milliseconds";
})(DateAccuracy || (DateAccuracy = {}));
/**
 * D, DT, DTS, DTMS, T, TS, TMS
 */
export function normalize(date, accuracy) {
    var result = new Date(date);
    switch (accuracy) {
        case DateAccuracy.Date:
            result.setHours(0, 0, 0, 0);
            break;
        case DateAccuracy.DateTime:
            result.setSeconds(0, 0);
            break;
        case DateAccuracy.DateTimeWithSeconds:
            result.setMilliseconds(0);
            break;
        case DateAccuracy.DateTimeWithMilliseconds:
            break;
        case DateAccuracy.Time:
            result.setFullYear(0, 0, 0);
            result.setSeconds(0, 0);
            break;
        case DateAccuracy.TimeWithSeconds:
            result.setFullYear(0, 0, 0);
            result.setMilliseconds(0);
            break;
        case DateAccuracy.TimeWithMilliseconds:
            result.setFullYear(0, 0, 0);
            break;
    }
    return result;
}
export function getWeekDay(date) {
    var day = date.getDay();
    if (day == 0) {
        return 6;
    }
    else {
        return day - 1;
    }
}
// https://stackoverflow.com/a/39502645
export function getWeekNumber(date) {
    if (!(date instanceof Date))
        date = new Date();
    // ISO week date weeks start on Monday, so correct the day number
    var nDay = (date.getDay() + 6) % 7;
    // ISO 8601 states that week 1 is the week with the first Thursday of that year
    // Set the target date to the Thursday in the target week
    date.setDate(date.getDate() - nDay + 3);
    // Store the millisecond value of the target date
    var n1stThursday = date.valueOf();
    // Set the target to the first Thursday of the year
    // First, set the target to January 1st
    date.setMonth(0, 1);
    // Not a Thursday? Correct the date to the next Thursday
    if (date.getDay() !== 4) {
        date.setMonth(0, 1 + ((4 - date.getDay()) + 7) % 7);
    }
    // The week number is the number of weeks between the first Thursday of the year
    // and the Thursday in the target week (604800000 = 7 * 24 * 3600 * 1000)
    return 1 + Math.ceil((n1stThursday - date) / 604800000);
}
export function copyDate(from, to) {
    to.setFullYear(from.getFullYear(), from.getMonth(), from.getDate());
}
